import { useMutation } from "@apollo/client";
import { removeCurrentUserToken } from "config/auth";
import { LogoutClient } from "domains/Users/graphql/mutations";
import React from "react";
import { useNavigate } from "react-router-dom";

export function Logout() {
  const navigation = useNavigate();
  const [logout] = useMutation(LogoutClient);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const removeAuthorizations = () => {
    removeCurrentUserToken()
      .catch(() => {})
      .finally(() => navigation("/login"));
  };
  React.useEffect(() => {
    logout()
      .catch(() => {})
      .finally(removeAuthorizations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>
  </>;
}

export default Logout;
